import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Question from "../../../images/icons/question.svg";
import { Button, FormControl, FormHelperText, InputAdornment, Modal, OutlinedInput } from "@material-ui/core";
import { REQUIRED_MESSAGE } from "../../../constants";
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 350,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "20px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
  formControl: {
    minWidth: 120,
  },
}));

const ModalConfirmWithValue = ({
  open,
  handleClick,
  handleClickOut
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [salary, setSalary] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onHandleClickOut = () => {
    setErrorMessage("");
    setSalary(null);
    handleClickOut();
  };

  const onAcceptButton = () => {
    const salario = salary;
    if (!salary) {
      setErrorMessage(REQUIRED_MESSAGE);
      return;
    }
    let removedDotsSalary = salario.replace(/\./g, "");
    let salaryWithoutDots = parseInt(removedDotsSalary);
    if (salaryWithoutDots > 999999999) {
      setErrorMessage("El valor máximo es $ 999.999.999")
      return;
    }
    if (salaryWithoutDots === 0) {
      setErrorMessage("El valor debe ser mayor a $ 0")
      return;
    }
    setErrorMessage("");
    setSalary(null);
    handleClick(salaryWithoutDots);
    onHandleClickOut()
  };

  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const handleSalaryKeyPress = (e) => {
    let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (!validChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const addValuesToMemory = (e) => {
    const { value } = e.target;
    let sal = addDots(removeNonNumeric(value));
    setSalary(sal);
    setErrorMessage("");
  };

  const iconsAlert = () => {
    return <img src={Question} alt="" style={{ width: "30%" }} />;
  };

  const renderButtons = (
    handleClick,
    handleClickOut
  ) => {
    return (
        <>
          <Button
            className={classes.accept}
            type="button"
            variant="contained"
            onClick={onHandleClickOut}
          >
            Cancelar
          </Button>

          <Button
            className={classes.cancel}
            type={"submit"}
            variant="contained"
            color="secondary"
            onClick={onAcceptButton}
          >
            Aceptar
          </Button>
        </>
      );
    };

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
      {iconsAlert()}
      { <p className={classes.text}>Por favor ingrese el valor devengado para el certificado</p> }
      <FormControl
              fullWidth
              size="small"
              className={
               classes.formField
              }
              style={{ marginBottom: "0px", marginTop: "8px" }}
              variant="outlined"
            >
              <OutlinedInput
                size="small"
                name="salary"
                value={salary}
                label="valor"
                id="outlined-adornment-amount"
                inputProps={{ maxLength: 11 }}
                onKeyPress={handleSalaryKeyPress}
                onChange={addValuesToMemory}
                disabled={false}
                required={true}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
                labelWidth={60}
              />
            </FormControl>

      <FormHelperText style={{ color: "#f44336", marginBottom: "20px" }}>
        {errorMessage ? errorMessage : null}
      </FormHelperText>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {renderButtons(
          handleClick,
          handleClickOut
        )}
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalConfirmWithValue;
